import {
  Computer,
  Email,
  Location,
  Mobile,
  Phone,
  Subdomain,
  User,
} from "neetoicons";
import {
  Apple,
  Chrome,
  Edge,
  Firefox,
  Safari,
  Ubuntu,
  Windows,
} from "neetoicons/misc";

export const BOOLEAN_VALUES_MAP = { true: "Yes", false: "No" };
export const ENTER = "enter";
export const ESCAPE = "escape";
export const PHONE_NUMBER = "phone_number";
export const INTEGER = "integer";
export const ICONS_MAP = {
  name: User,
  user: User,
  email: Email,
  phone_number: Phone,
  location: Location,
  timezone: Subdomain,
  chrome: Chrome,
  safari: Safari,
  firefox: Firefox,
  edge: Edge,
  ie: Edge,
  windows: Windows,
  mac_os: Apple,
  linux: Ubuntu,
  mobile: Mobile,
  desktop: Computer,
};
